import React, {
    Component,
} from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Intercom from 'wanderu-component-intercom';
import {
    fetchHomepageInterlinksAction,
    interlinkDataSelectors,
} from 'wanderu-ducks-interlink';
import {
    i18nCoordinator,
    selectCurrency,
    selectLocale,
} from 'wanderu-i18n';
import { carrierMap as carrierData } from 'wanderu-utils';
import Widget from 'wanderu-widget';

import localesConfig from '../../../config/homepage.locales';
import HomePage from '../../components/HomePage/HomePage';

class HomePageContainer extends Component {
    static defaultProps = {
        interlinkData: [],
    };

    static serverFetchData(opts) {
        const {
            dispatch,
            getState,
            i18nCoordinator: serverI18nCoordinator,
        } = opts;

        const locale = selectLocale(getState());

        serverI18nCoordinator.registerTranslatableApp({
            ...localesConfig,
            translationFetchFn: (loc) => {
                return import(`../../translations/homepage/${loc}.po`);
            },
        });

        return Promise.all([
            Widget.serverFetchData(opts),
            dispatch(fetchHomepageInterlinksAction.fetchHomepageInterlinks({ locale })),
        ]);
    }

    componentDidMount() {
        const {
            isLoaded,
            locale,
        } = this.props;

        if (!isLoaded) {
            this.props.fetchHomepageInterlinks({ locale });
        }

        i18nCoordinator.registerTranslatableApp({
            ...localesConfig,
            translationFetchFn: (loc) => {
                return import(`../../translations/homepage/${loc}.po`);
            },
        });
    }

    componentDidUpdate(prevProps) {
        const {
            locale: newLocale,
        } = this.props;
        const {
            locale: previousLocale,
        } = prevProps;

        if (newLocale !== previousLocale) {
            this.props.fetchHomepageInterlinks({ locale: newLocale });
        }
    }

    componentWillUnmount() {
        this.props.resetHomepageInterlinkData();
    }

    getCarriers() {
        const { locale } = this.props;
        return carrierData[locale];
    }

    render() {
        const carriers = this.getCarriers();
        const {
            currency,
            interlinkData,
            locale,
            staticContext,
        } = this.props;

        if (staticContext) {
            staticContext.cache = {
                secondsFromNow: 60 * 60 * 24 * 7,
            };
        }

        return (
            <>
                <HomePage
                    carriers={carriers}
                    currency={currency}
                    interlinkData={interlinkData}
                    locale={locale}
                />
                <Intercom />
            </>

        );
    }
}

HomePageContainer.propTypes = {
    currency: PropTypes.string.isRequired,
    fetchHomepageInterlinks: PropTypes.func.isRequired,
    interlinkData: PropTypes.arrayOf(PropTypes.object),
    isLoaded: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    resetHomepageInterlinkData: PropTypes.func.isRequired,
    staticContext: PropTypes.shape({
        cache: PropTypes.object,
    }),
};

function mapStateToProps(state) {
    return {
        currency: selectCurrency(state),
        interlinkData: interlinkDataSelectors.selectHomepageData(state),
        isLoaded: fetchHomepageInterlinksAction.selectSuccess(state)
            || !!fetchHomepageInterlinksAction.selectError(state),
        locale: selectLocale(state),
    };
}

const mapDispatchToProps = {
    fetchHomepageInterlinks: fetchHomepageInterlinksAction.fetchHomepageInterlinks,
    resetHomepageInterlinkData: fetchHomepageInterlinksAction.reset,
};

export {
    HomePageContainer,
    mapStateToProps,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
